<script setup lang="ts">
import { cn } from '@/libs/tailwind'

const props = defineProps<{
  flat?: boolean
}>()

const className = cn(
  "font-['Be Vietnam Pro']",
  'font-[700]',
  'text-[16px]',
  'leading-[20px]',
  'tracking-[-0.5px]',
  'text-center',
  'align-middle',
  'bg-[#006561]',
  'rounded-[16px]',
  'gap-[8px]',
  'py-[18px]',
  'cursor-pointer',
  props.flat && 'bg-transparent',
  props.flat && 'border-[#D9EEED]',
  props.flat && 'border-[2px]',
  props.flat ? 'text-[#00201f]' : 'text-[#ffffff0]'
)
</script>
<template>
  <div :class="className">
    <slot></slot>
  </div>
</template>
